<i18n locale="en">
{
  "heading": "Untappd beer menu",
  "configured": "The live Untappd menu will render here on the published website.",
  "unconfigured": "Add your Untappd embed information to configure this integration."
}
</i18n>

<template>
  <PreviewSheet
    class="integrations-preview"
    data-testid="website-integration-preview"
  >
    <div class="flex-col gap-4">
      <PreviewTypography :text="t('heading')" variant="heading4" />
      <PreviewTypography
        :text="configured ? t('configured') : t('unconfigured')"
        variant="paragraphRegular"
        :color="configured ? undefined : 'secondary'"
      />
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

import type { IntegrationsSection } from '../../../WebsiteBuilder.types'

const props = defineProps<{ content: IntegrationsSection }>()
const { t } = useI18n()
const configured = computed(() => {
  const { params } = props.content
  return (
    params.providerType === 'untappd' &&
    Boolean(params.locationId && params.themeId)
  )
})
</script>

<style lang="scss" scoped>
.integrations-preview {
  padding: 120px;
}
</style>
